import i18n from "i18n-js";
import Localization from '../shared/Localization';

let local: typeof i18n;

Localization('en').then(localRes => local = localRes);
class ErrorMessages {
    static INVALID_PASSWORD_LENGTH = (n: number) => local?.t("errorMessage.invalidPasswordLength", { number: n });
    static PASSWORD_NUMBER_REQUIRED = () => local?.t("errorMessage.passwordNumberRequired");
    static PASSWORD_LOWERCASE_REQUIRED = () => local?.t("errorMessage.passwordLowerCaseRequired");
    static PASSWORD_UPPERCASE_REQUIRED = () => local?.t("errorMessage.passwordUppercaseRequired");

    static WRONG_DOMAIN = (domain: string) => local?.t("errorMessage.wrongDomain", { domain: domain });
    static JUST_DOMAIN = () => local?.t("errorMessage.justDomain");
    static NO_WHITESPACE = () => local?.t("errorMessage.noWhitespace");
}

export { ErrorMessages }